export default "__VITE_ASSET__DcQ$W$bm__"